export default __webpack_public_path__ + "static/media/money.e63839ce.JPG";